"use client";

import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { CheckIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { webAssetsCdnBaseUrl } from "../constants";
import { generateTemplateDetailsPath } from "./slug";
import { TemplateData } from "./templates-action";
import { classNames } from "@/helpers/tailwind-class";
import { trackEvent } from "@/shared/analytics-wrapper";

export function SocialShare({ template }: { template: TemplateData }) {
  const [url, setUrl] = useState("");
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    setUrl(`${window.location.origin}/${generateTemplateDetailsPath(template)}`);
  }, []);

  const linkProps = {
    className:
      "rounded-full bg-slate-800 hover:bg-slate-700 h-8 w-8 flex items-center justify-center border-slate-800 border relative",
  };

  return (
    <div className="flex items-center justify-start gap-4">
      <div>Share On</div>

      <button
        {...linkProps}
        onClick={() => {
          trackEvent({
            eventName: "templateSocialShare",
            action: "click",
            category: "facebook",
          });
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&display=page`, "_blank");
        }}
      >
        <img
          height={26}
          width={26}
          src={`${webAssetsCdnBaseUrl}/social/facebook.svg`}
          alt={"Facebook Icon"}
        />
      </button>

      <button
        {...linkProps}
        onClick={() => {
          trackEvent({
            eventName: "templateSocialShare",
            action: "click",
            category: "twitter",
          });
          window.open(`https://twitter.com/intent/tweet?text=${url}`, "_blank");
        }}
      >
        <img
          height={16}
          width={16}
          src={`${webAssetsCdnBaseUrl}/social/x.svg`}
          alt={"Twitter Icon"}
        />
      </button>

      <button
        {...linkProps}
        onClick={() => {
          trackEvent({
            eventName: "exploreVideoSocialShare",
            action: "click",
            category: "reddit",
          });
          window.open(
            `https://www.reddit.com/submit?url=${url}&title=Awesome%20AI%20Video`,
            "_blank"
          );
        }}
      >
        <img
          height={30}
          width={30}
          src={`${webAssetsCdnBaseUrl}/social/reddit.svg`}
          alt={"Reddit Icon"}
        />
      </button>

      <button
        {...linkProps}
        onClick={() => {
          trackEvent({
            eventName: "templateSocialShare",
            action: "click",
            category: "copyUrl",
          });

          navigator.clipboard.writeText(url);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 5000);
        }}
        aria-label="Copy URL"
      >
        <CheckIcon
          className={classNames(
            "absolute inset-1 block h-6 w-6 text-slate-300 transition-opacity duration-300",
            isCopied ? "opacity-100" : "opacity-0"
          )}
        />
        <DocumentDuplicateIcon
          className={classNames(
            "absolute inset-1 block h-6 w-6 text-slate-300 transition-opacity duration-300",
            isCopied ? "opacity-0" : "opacity-100"
          )}
        />
      </button>
    </div>
  );
}
